import Button from '../../components/Button';
import styles from './DriverSuccessModal.module.css';

export default function DriverSuccessModal({
  icon: Icon, title, text, buttonLabel, onButtonClick,
}) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.icon}>
          <Icon size={30} />
        </div>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.text}>{text}</p>
        <Button size="lg" variant="primary" className={styles.btn} onClick={onButtonClick}>
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
}
